module.exports = __webpack_public_path__ + "img/4N.c0ed9b5c.png";